<script>
import { Line, mixins } from 'vue-chartjs';

export default {
  extends: Line,
  props: ['chartdata', 'sum'],
  data() {
    return {
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: true,
              },
              ticks: {
                callback: function (value, index) {
                  let datasets = this.chartdata.datasets;
                  let ySum = 0;
                  datasets.forEach(e => {
                    ySum += e.data[index];
                  });
                  let percentage = ((ySum / this.sum) * 100).toFixed(1);
                  return value + ' ' + percentage + '%';
                }.bind(this),
              },
            },
          ],
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        hover: {
          mode: 'nearest',
          intersect: true,
        },
        legend: {
          display: true,
        },
        title: {
          display: true,
          text: '요일별 방문자 현황',
        },

        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  methods: {},
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
};
</script>
